import React from "react";
import { Link } from "react-router-dom";



export default function VehicleAccessoryDetail1() {
    return (
        <div className="vehicleaccessorydetail-container my-4">
            {/* Header */}
            <div className="special-header d-flex justify-content-between align-iteam">
            <h4 className="page-title pt-2">Vehicle Accessory Details</h4>
            <div className="d-flex justify-content-between gap-2">
             <Link to="/updatevehiclefine" type="button" className="btn custom-btn">Edit</Link>
              <button type="button" className="btn custom-btn">Delete</button>
             </div>
            </div>

            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table  table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Vehicle Name</td>
                                    <td>Safe Student</td>

                                </tr>
                                <tr>

                                    <td>Accessory Item</td>
                                    <td>Side Mirror</td>

                                </tr>
                                <tr>

                                    <td>Quantity</td>
                                    <td>23</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Price</td>
                                    <td>$1000</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Purchase From</td>
                                    <td>Shop</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Purchase Date</td>
                                    <td>Thu Mar 3 2022</td>
                                   
                                </tr>
                                <tr>

                                    <td>Invoice</td>
                                    <td>View Invoice</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>

    );

}